import { render } from "./TechnoList.vue?vue&type=template&id=129a3676"
import script from "./TechnoList.vue?vue&type=script&lang=js"
export * from "./TechnoList.vue?vue&type=script&lang=js"

import "./TechnoList.vue?vue&type=style&index=0&id=129a3676&lang=css"
script.render = render

export default script